import dayjs from "dayjs";
import "dayjs/locale/en-gb";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";
import localizedFormat from "dayjs/plugin/localizedFormat";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

// Single source of truth for dayjs plugin registration + locale/timezone defaults.
// Import this once at the app entry (index.tsx) and in the test/storybook setup so
// the dayjs singleton is fully configured before any code uses it — instead of each
// leaf module calling dayjs.extend() and relying on module load order (which breaks
// under code-splitting). dayjs is a singleton, so extending it here configures every
// `import dayjs from "dayjs"` caller. The guardrail test asserts no other module
// calls dayjs.extend. utc must be extended before timezone (timezone depends on it).
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);
dayjs.extend(localizedFormat);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);

dayjs.locale("en-GB");
dayjs.tz.setDefault("Europe/London");

export default dayjs;
